import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BaseService } from '../../../shared/services/base.service';
import { TranslationRequest } from '../../../shared/models/translationRequest';
import { Observable } from 'rxjs';
import { TranslationResponse } from '../../../shared/models/translationResponse';

@Injectable({
  providedIn: 'root',
})
export class TranslationFieldService extends BaseService {
  constructor() {
    const http = inject(HttpClient);

    super(http);
  }

  public translateString(translationRequest: TranslationRequest): Observable<TranslationResponse> {
    return this.post<TranslationResponse>('v1/Translate/text', translationRequest);
  }
}
